import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { MapState, MapActions, createMapSlice } from "./slices/mapSlice";
import {
  ActiveToolsState,
  ActiveToolsActions,
  createActiveToolsSlice,
} from "./slices/activeToolsSlice";
import {
  ResultsState,
  ResultsActions,
  createResultsSlice,
} from "./slices/resultsSlice";
import {
  LayersState,
  LayersActions,
  createLayersSlice,
} from "./slices/layersSlice";

import {
  MarkupToolsState,
  MarkupToolsActions,
  createMarkupToolsSlice,
} from "./slices/markupToolsSlice";

import {
  ReportsState,
  ReportsActions,
  createReportsSlice,
} from "./slices/reportsSlice";

import { AuthState, AuthActions, createAuthSlice } from "./slices/authSlice.ts";
import { BaseConfig } from "../interfaces/config.ts";
import {
  AdminActions,
  AdminState,
  createAdminSlice,
} from "./slices/adminSlice.ts";

export type DataStore = {
  config: BaseConfig | null;
  setConfig: (config: BaseConfig) => void;
} & MapState &
  MapActions &
  ActiveToolsState &
  ActiveToolsActions &
  ResultsState &
  ResultsActions &
  LayersState &
  LayersActions &
  AuthState &
  AuthActions &
  AdminState &
  AdminActions &
  MarkupToolsState &
  MarkupToolsActions &
  ReportsState &
  ReportsActions;

export const useStore = create<DataStore>()(
  subscribeWithSelector((set, get) => ({
    config: null,
    setConfig: (config) => set({ config }),
    ...createMapSlice(set, get),
    ...createActiveToolsSlice(set, get),
    ...createResultsSlice(set, get),
    ...createLayersSlice(set, get),
    ...createAuthSlice(set, get),
    ...createAdminSlice(set, get),
    ...createMarkupToolsSlice(set, get),
    ...createReportsSlice(set, get),
  }))
);

useStore.subscribe(
  (state) => state.globalSelectedBasemap,
  (newBasemap, prevBasemap) => {
    if (newBasemap?.id !== prevBasemap?.id) {
      const results = useStore.getState().results;
      if (results && results.length > 0) {
        useStore.getState().rehighlightResults();
      }
    }
  }
);
